import { render, staticRenderFns } from "./HomeNavigation.vue?vue&type=template&id=8f8179ae"
import script from "./HomeNavigation.vue?vue&type=script&lang=js"
export * from "./HomeNavigation.vue?vue&type=script&lang=js"
import style0 from "./HomeNavigation.vue?vue&type=style&index=0&id=8f8179ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports